import React from "react";
import styled from "styled-components";
import { MyButton } from "../../../components/Button/style";
import ModalConnectWallet from "./ModalConnectWallet";
import { useApp } from "../../../contexts";
const Waper = styled.div`
  width: 100%;
  height: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 320px);
  @media (max-width: 768px) {
    align-items: start;
    min-height: calc(100vh - 420px);
  }
  @media (max-width: 1024px) {
    height: 50%;
    min-height: calc(100vh - 350px);
  }
`;
const Content = styled.div`
  width: 622px;
  max-width: 90%;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 10px 30px rgba(77, 103, 193, 0.14902);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 39px;
  @media (max-width: 1366px) {
    width: 504px;
    border-radius: 30px;
    height: 201px;
  }
  @media (max-width: 768px) {
    box-shadow: none;
    max-width: 355px;
    gap: 46px;
  }
`;

const Text = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #4f4f4f;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 25px;
    max-width: 242px;
    display: inline-block;
  }
`;

const ButtonCustom = styled(MyButton)`
  height: 52px;
  width: 250px;

  @media (max-width: 500px) {
    width: 100%;
  }
`;

const ScreenConnectWallet = () => {
  const { T } = useApp();
  const [isVisibleModal, setIsVisibleModal] = React.useState(false);
  return (
    <Waper>
      <Content>
        <Text>{T("You need to connect wallet to use this function")}</Text>
        <ButtonCustom
          className="primary"
          onClick={() => setIsVisibleModal(true)}
        >
          {T("Connect")}
        </ButtonCustom>
      </Content>
      {isVisibleModal && (
        <ModalConnectWallet onClose={() => setIsVisibleModal(false)} />
      )}
    </Waper>
  );
};

export default ScreenConnectWallet;
